import React from 'react'
import UserChildrenContent from '../Components/Children/UserChildrenContent';
import LoginLayout from '../Layouts/LoginLayout';

export default function UserChildren() {
  return (
    <LoginLayout>
        <UserChildrenContent />
    </LoginLayout>
  )
}
